import { FilterInput } from './filter-input';
import { SortOption } from './sort-option';
import {
  Document,
  EmployeeFilterKeys,
  EmployeeSortInput,
  OpportunityFilterKeys,
  OpportunitySortInput,
  ProjectFilterKey,
  ProjectSortInput,
} from './types.generated';
import { AdvancedFilterInput } from './advanced-filter-input';

export type TypedDocument<TFilterInput extends FilterInput, TSortInput extends SortOption> = Omit<
  Required<Document>,
  '__typename' | 'data'
> & {
  data: Partial<TFilterInput & TSortInput>;
};

export type NullSortInput = {
  field: undefined;
};

export enum DocumentContext {
  OPPORTUNITIES_FILTER = 'opportunities-filter',
  PROJECTS_FILTER = 'projects-filter',
  EMPLOYEES_FILTER = 'employees-filter',
  DAILY_RATES = 'daily-rates',
}

export interface RegularJsonDocument {
  [key: string]: string | number | boolean | RegularJsonDocument;
}

export type DashboardProperties = {
  showOnDashboard?: boolean;
  sortPosition?: number;
};

export interface DocumentWithContext {
  [DocumentContext.OPPORTUNITIES_FILTER]: TypedDocument<
    AdvancedFilterInput<OpportunityFilterKeys>,
    OpportunitySortInput & DashboardProperties
  >;

  [DocumentContext.PROJECTS_FILTER]: TypedDocument<
    AdvancedFilterInput<ProjectFilterKey>,
    ProjectSortInput & DashboardProperties
  >;

  [DocumentContext.EMPLOYEES_FILTER]: TypedDocument<
    AdvancedFilterInput<EmployeeFilterKeys>,
    EmployeeSortInput & DashboardProperties
  >;

  [DocumentContext.DAILY_RATES]: TypedDocument<RegularJsonDocument, NullSortInput & DashboardProperties>;
}

export type DashboardComponentUrl = {
  base: string;
  params: {
    filter: any;
    sort: any;
  };
};

export type DashboardComponent = {
  id: string;
  titleKey?: string;
  iconName: string;
  tooltipKey?: string;
  filterDoc?: Document;
  url?: DashboardComponentUrl;
  sortPosition?: number;
};
